export class Tax {

    public id: string = "0";
    public name: string;
    public value: Number;
    
    constructor() {}
}